<template>
  <el-dialog width="1200px" title="订单详情" :visible="visible" @close="close">
    <!-- <div class="content">
      <ul class="info-list">
        <li class="mb20">
          <div class="title">基本信息</div>
          <div class="mb20">
            <el-table stripe border :data="[detailsOrder.order]" size="small">
              <el-table-column
                header-align="center"
                align="center"
                prop="receiptSn"
                label="订单号"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="spuName"
                label="发货单流水号"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="memberMobile"
                label="会员手机号"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="payMode"
                label="支付方式"
              >
                <template slot-scope="scope">
                  <span
                    class="status danger"
                    v-if="scope.row.payMode === 'no_pay'"
                    >未支付</span
                  >
                  <span
                    class="status danger"
                    v-if="scope.row.payMode === '0_pay'"
                    >0元订单</span
                  >
                  <span
                    class="status danger"
                    v-if="scope.row.payMode === 'wx_pay'"
                    >微信支付</span
                  >
                  <span
                    class="status danger"
                    v-if="scope.row.payMode === 'ali_pay'"
                    >支付支付</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="orderSource"
                label="订单来源"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.orderSource === 'wxShop'"
                    >微店订单</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="orderType"
                label="订单类型"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.orderType === 'wshop'">微店订单</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="mb20">
            <el-table stripe border :data="[detailsOrder.order]" size="small">
              <el-table-column
                header-align="center"
                align="center"
                prop="deliveryType"
                label="配送方式"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.deliveryType === 'mdzt'">门店自提</span>
                  <span v-if="scope.row.deliveryType === 'kdfh'">快递发货</span>
                  <span v-if="scope.row.deliveryType === 'tcps'">同城配送</span>
                </template>
              </el-table-column>
              <el-table-column
                v-if="detailsOrder.order.deliveryType === 'mdzt'"
                header-align="center"
                align="center"
                prop="billNo"
                label="提货单号"
              ></el-table-column>
              <el-table-column
                v-else
                header-align="center"
                align="center"
                prop="expressOrderSn"
                label="物流单号"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="spuName"
                label="自动确认收货时间"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="orderRemark"
                label="订单备注"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="spuName"
                label="活动信息"
              ></el-table-column>
            </el-table>
          </div>
        </li>
        <li class="mb20">
          <div class="title">收货人信息</div>
          <el-table stripe border :data="[detailsOrder.order]" size="small">
            <el-table-column
              header-align="center"
              align="center"
              prop="receiverName"
              label="收货人"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="receiverMobile"
              label="手机号码"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="spuName"
              label="邮政编码"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="deliveryAddress"
              label="收货地址"
            >
              <template slot-scope="scope">
                <span
                  >{{ scope.row.deliveryProvince
                  }}{{ scope.row.deliveryAddress }}</span
                >
              </template>
            </el-table-column>
          </el-table>
        </li>
        <li class="mb20">
          <div class="title">商品信息</div>
          <el-table
            border
            :data="detailsOrder.orderGoods"
            size="small"
            :row-class-name="tableRowClassName"
          >
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsImg"
              label="商品图片"
            >
              <template slot-scope="scope">
                <div>
                  <img
                    class="warning-tuikuan"
                    v-show="scope.row.returnType === 'yes'"
                    src="https://imgcdn.hemiao100.com/hemiaoBase/%E5%B7%B2%E9%80%80%E6%AC%BE.png"
                    alt=""
                  />
                  <img
                    class="warning-tuikuan"
                    v-show="scope.row.returnType === 'doing'"
                    src="https://imgcdn.hemiao100.com/hemiaoBase/%E9%80%80%E6%AC%BE%E4%B8%AD.png"
                    alt=""
                  />

                  <img
                    style="width:100px;height:100px;"
                    v-if="scope.row.goodsImg"
                    :src="scope.row.goodsImg"
                    alt=""
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="spuName"
              label="商品名称/品牌"
            >
              <template slot-scope="scope">
                <p>{{ scope.row.spuName }}</p>
                <p>品牌: {{ scope.row.brandName }}</p>
                <el-tag type="warning"
                  >{{
                    scope.row.spuType === "virtual" ? "虚拟" : "实物"
                  }}商品</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="spuName"
              label="价格/货号"
              width="200"
            >
              <template slot-scope="scope">
                <p>价格: {{ scope.row.totalPrice }}</p>
                <p>货号: {{ scope.row.goodsSn }}</p>
                <p>条码: {{ scope.row.barCode }}</p>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="spuName"
              label="净重/毛重"
            >
              <template slot-scope="scope">
                <p v-if="scope.row.netWeight">
                  净重: {{ scope.row.netWeight }}
                </p>
                <p v-if="scope.row.grossWeight">
                  毛重: {{ scope.row.grossWeight }}
                </p>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="specIdGroupName"
              label="规格"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsNum"
              label="数量"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="totalPrice"
              label="小计"
            >
              <template slot-scope="scope">
                <p>
                  {{ scope.row.totalPrice * scope.row.goodsNum }}
                </p>
              </template>
            </el-table-column>
          </el-table>
        </li>
        <li class="mb20">
          <div class="title">费用信息</div>
          <el-table stripe border :data="[detailsOrder.order]" size="small">
            <el-table-column
              header-align="center"
              align="center"
              prop="totalPrice"
              label="商品合计"
            >
              <template slot-scope="scope">
                <p>￥{{ scope.row.totalPrice }}</p>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="deliverMoney"
              label="运费"
            >
              <template slot-scope="scope">
                <p>￥{{ scope.row.deliverMoney }}</p>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="couponMoney"
              label="优惠券"
              width="220"
            >
              <template slot-scope="scope">
                <div
                  class="primary"
                  v-for="(v, i) in scope.row.orderCouponInfoModels"
                  :key="i"
                >
                  {{ v.ruleName }} {{ v.couponCode }}
                </div>
                <div class="status primary">-￥{{ scope.row.couponMoney }}</div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="spuName"
              label="积分抵扣"
            >
              --
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="activeMoney"
              label="活动优惠"
            >
              <template slot-scope="scope">
                <span class="status danger"
                  >-￥{{ scope.row.activeMoney }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="actuallyPrice"
              label="实付金额"
            >
              <template slot-scope="scope">
                <span class="status danger"
                  >￥{{ scope.row.actuallyPrice }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="payPrice"
              label="应付金额"
            >
              <template slot-scope="scope">
                <span class="status danger">￥{{ scope.row.payPrice }}</span>
              </template>
            </el-table-column>
          </el-table>
        </li>
      </ul>
    </div> -->
    <div slot="title">
      <span class="mr10">订单详情</span>
      <span class="form-item-tip" style="color: #fF0000"
        >当前订单状态：{{ orderSta }}</span
      >
    </div>
    <div class="content">
      <!-- <div class="progress">
        <el-steps :active="active" align-center>
          <el-step title="创建订单" :description="createOrderTime"></el-step>
          <el-step title="支付订单" :description="payOrderTime"></el-step>
          <el-step
            title="平台配货发货"
            :description="deliverOrderTime"
          ></el-step>
          <el-step title="确认收货" :description="takeOrderTime"></el-step>
          <el-step title="完成评价" :description="pushOrderTime"></el-step>
        </el-steps>
      </div> -->
      <ul class="info-list mt10">
        <li>
          <div class="title">基本信息</div>
          <div class="mb20">
            <el-table stripe border :data="[orderDetails]" size="small">
              <el-table-column
                header-align="center"
                align="center"
                prop="receiptSn"
                label="订单信息"
              >
                <template slot-scope="scope">
                  <div class="text-left">
                    <div>订单号：{{ scope.row.receiptSn }}</div>
                    <div>
                      是否拆单发货：{{ scope.row.packageNum > 1 ? "是" : "否" }}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="shareMemberName"
                label="推荐关系"
              >
                <template slot-scope="scope">
                  <div class="text-left">
                    <div>
                      推荐类型：{{
                        scope.row.shareMemberName !== null &&
                        scope.row.platformId !== "smg"
                          ? "分销"
                          : ""
                      }}
                    </div>
                    <div>
                      分销会员：{{ scope.row.shareMemberName }}/{{
                        scope.row.shareMemberMobile
                      }}
                    </div>
                    <div>所属机构：{{ scope.row.departName }}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="receiptSn"
                label="订单主体"
              >
                <template slot-scope="scope">
                  <div class="text-left">
                    <div>下单会员：{{ scope.row.memberName }}</div>
                    <div>
                      收货人：{{ scope.row.receiverName }}/{{
                        scope.row.receiverMobile
                      }}
                    </div>
                    <div>
                      收货地址：{{ scope.row.deliveryProvince
                      }}{{ scope.row.deliveryAddress }}
                    </div>
                    <!-- <el-button
                      size="small"
                      type="text"
                      class="blue"
                      @click="editDeliveryInfo(scope.row, 'detail')"
                      >修改收货信息</el-button
                    > -->
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="receiptSn"
                label="费用信息"
              >
                <template slot-scope="scope">
                  <div class="text-left">
                    <div>商品合计：{{ scope.row.totalPrice }}</div>
                    <div>优 惠 券：-{{ scope.row.couponMoney }}</div>
                    <div>优惠券信息：{{ scope.row.couponName }}</div>
                    <div>活动：-{{ scope.row.activeMoney }}</div>
                    <div>运 费：{{ scope.row.deliverMoney }}</div>
                    <div v-if="scope.row.deliverCouponMoney">
                      运费券：-{{ scope.row.deliverCouponMoney }}
                    </div>
                    <div class="flex flex-between">
                      <div>储 值 卡：-{{ scope.row.prepayMoney }}</div>
                      <div
                        style="fontWeight:600"
                        v-if="orderDetails.payMode !== 'no_pay'"
                      >
                        实付款：{{ scope.row.actuallyPrice }}
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </li>
        <li class="mb20">
          <div class="flex flex-between">
            <div class="title">商品信息</div>
            <!-- <div
              class="flex flex-end item-center"
              v-if="orderDetails.payMode !== 'no_pay' && isBtn('tuikuan:false')"
            >
              <span class="pointer mr10" @click="batchReturn">
                <span class="hmicon icon-tuikuan"> </span>
                批量退款
              </span>
            </div> -->
          </div>

          <el-table
            border
            :data="orderGoods"
            :span-method="objectSpanMethod"
            size="small"
            :row-class-name="tableRowClassName"
          >
            <!-- <el-table-column
              type="selection"
              width="50"
              header-align="center"
              align="center"
              :selectable="checkSelectable"
              v-show="
                orderDetails.payMode !== 'no_pay' && isBtn('tuikuan:false')
              "
            >
            </el-table-column> -->
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsImg"
              label="商品图片"
            >
              <template slot-scope="scope">
                <div>
                  <div
                    class="flex flex-center item-center"
                    v-if="scope.row.returnType !== 'no'"
                  >
                    <!-- 仅退款 -->
                    <img
                      v-if="scope.row.refundReturnType === 'money'"
                      style="width:100px;height:100px"
                      src="https://imgcdn.hemiao100.com/hemiaoBase/81d2994f64c85809bf951f14fd56ecc.png"
                      alt=""
                    />

                    <!-- 退货退款 -->
                    <img
                      v-if="scope.row.refundReturnType === 'refund'"
                      style="width:100px;height:100px"
                      src="https://imgcdn.hemiao100.com/hemiaoBase/8088827e177ba800a9eba2c17e295c8.png"
                      alt=""
                    />

                    <!-- 退运费 -->
                    <img
                      v-if="scope.row.refundReturnType === 'deliver'"
                      style="width:100px;height:100px"
                      src="https://imgcdn.hemiao100.com/hemiaoBase/9a0ad12b4cead9d04371c126a61d5d5.png"
                      alt=""
                    />
                  </div>

                  <img
                    class="warning-tuikuan"
                    v-show="scope.row.returnType === 'yes'"
                    src="https://imgcdn.hemiao100.com/hemiaoBase/%E5%B7%B2%E9%80%80%E6%AC%BE.png"
                    alt=""
                  />
                  <img
                    class="warning-tuikuan"
                    v-show="scope.row.returnType === 'doing'"
                    src="https://imgcdn.hemiao100.com/hemiaoBase/%E9%80%80%E6%AC%BE%E4%B8%AD.png"
                    alt=""
                  />
                  <div
                    class="flex flex-center item-center"
                    :class="scope.row.returnType !== 'no' ? 'only-tuikuan' : ''"
                  >
                  <div>
                    <img
                      style="width:100px;height:100px;"
                      v-if="scope.row.goodsImg"
                      :src="scope.row.goodsImg"
                      alt=""
                    />
                    <div style="width:100%">
                          <el-tag
                            style="width:100%"
                            size="mini"
                            effect="plain"
                            type="success"
                            v-if="scope.row.isGift === 'gift'"
                            >赠 品</el-tag
                          >
                          <el-tag
                            style="width:100%"
                            size="mini"
                            effect="dark"
                            type="success"
                            v-else-if="scope.row.isGift === 'markup'"
                            >加价购商品</el-tag
                          >
                        </div>
                  </div>
                    
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="spuName"
              label="商品名称/品牌"
            >
              <template slot-scope="scope">
                <p>{{ scope.row.spuName }}</p>
                <p>品牌: {{ scope.row.brandName }}</p>
                <el-tag type="warning"
                  >{{
                    scope.row.spuType === "virtual" ? "虚拟" : "实物"
                  }}商品</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="spuName"
              label="价格/货号"
            >
              <template slot-scope="scope">
                <p>价格: {{ scope.row.totalPrice }}</p>
                <p>货号: {{ scope.row.goodsSn }}</p>
                <p>条码: {{ scope.row.barCode }}</p>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="spuName"
              label="净重/毛重"
            >
              <template slot-scope="scope">
                <p v-if="scope.row.netWeight">
                  净重: {{ scope.row.netWeight }}
                </p>
                <p v-if="scope.row.grossWeight">
                  毛重: {{ scope.row.grossWeight }}
                </p>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="specIdGroupName"
              label="规格"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsNum"
              label="数量"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="totalPrice"
              label="小计"
            >
              <template slot-scope="scope">
                <p>
                  {{ scope.row.totalPrice * scope.row.goodsNum }}
                </p>
              </template>
            </el-table-column>
            <!-- <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <div
                  v-if="
                    orderDetails.payMode !== 'no_pay' && isBtn('tuikuan:false')
                  "
                >
                  <el-button
                    v-if="
                      (scope.row.spuType === 'virtual' &&
                        scope.row.memberLaunchRefund === 'yes') ||
                        scope.row.spuType !== 'virtual'
                    "
                    :disabled="scope.row.returnType !== 'no'"
                    size="small"
                    class="danger"
                    type="text"
                    @click="refund(scope.row)"
                    >退款</el-button
                  >
                </div>
              </template>
            </el-table-column> -->
            <el-table-column
              header-align="center"
              prop="expressQueryId"
              label="包裹信息"
              width="220"
            >
              <template slot-scope="scope">
                <div>
                  <div>
                    <el-tag
                      size="mini"
                      effect="plain"
                      color="#FFEEF6"
                      v-if="scope.row.expressState === 'waitAllocation'"
                      >待配货</el-tag
                    >
                    <el-tag
                      size="mini"
                      effect="plain"
                      color="#FFEEF6"
                      v-if="scope.row.expressState === 'waitDeliver'"
                      >待发货</el-tag
                    >
                    <el-tag
                      size="mini"
                      effect="plain"
                      color="#FFEEF6"
                      v-if="scope.row.expressState === 'alreadyDeliver'"
                      >已发货</el-tag
                    >
                    <el-tag
                      size="mini"
                      effect="plain"
                      color="#FFEEF6"
                      v-if="!!scope.row.supplierId"
                      >三方</el-tag
                    >
                    <el-tag size="mini" effect="plain" color="#FFEEF6" v-else
                      >自营</el-tag
                    >
                  </div>
                  <div>发货单号:{{ scope.row.deliverSn }}</div>
                  <div>快递单号:{{ scope.row.expressOrderSn }}</div>
                  <div
                    class="mb10"
                    v-if="scope.row.expressState === 'alreadyDeliver'"
                  >
                    发货门店：{{ scope.row.sendShopName }}
                  </div>
                  <div v-if="scope.row.expressState === 'alreadyDeliver'">
                    发货时间：{{ scope.row.sendTime }}
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </li>
        <li class="mb20">
          <div class="title">操作信息</div>
          <el-table stripe border :data="orderStatus" size="small">
            <el-table-column
              header-align="center"
              align="center"
              prop="operatorAccount"
              label="操作账号"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="operatorName"
              label="操作人"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.operatorName === null">
                  {{ scope.row.createBy }}
                </div>
                <div v-else>
                  {{ scope.row.operatorName }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="createTime"
              label="操作时间"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="spuName"
              label="订单状态"
            >
              <template slot-scope="scope">
                <span
                  class="status blue"
                  v-if="scope.row.orderStatus === 'createOrder'"
                  >待付款</span
                >
                <span
                  class="status blue"
                  v-if="scope.row.orderStatus === 'payOrder'"
                  >待发货</span
                >
                <span
                  class="status blue"
                  v-if="scope.row.orderStatus === 'deliverOrder'"
                  >已发货</span
                >
                <span
                  class="status blue"
                  v-if="scope.row.orderStatus === 'takeOrder'"
                  >已收货</span
                >
                <span
                  class="status blue"
                  v-if="scope.row.orderStatus === 'pushOrder'"
                  >已评价</span
                >
                <span
                  class="status blue"
                  v-if="scope.row.orderStatus === 'delOrder'"
                  >已取消</span
                >
                <span
                  class="status blue"
                  v-if="scope.row.orderStatus === 'returnOrder'"
                  >有退货退款</span
                >
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="spuName"
              label="付款状态"
            >
              <template slot-scope="scope">
                <span
                  class="status blue"
                  v-if="scope.row.orderStatus === 'createOrder'"
                  >未付款</span
                >
                <span
                  class="status blue"
                  v-if="scope.row.orderStatus === 'payOrder'"
                  >已付款</span
                >
                <span
                  class="status blue"
                  v-if="scope.row.orderStatus === 'deliverOrder'"
                  >已付款</span
                >
                <span
                  class="status blue"
                  v-if="scope.row.orderStatus === 'takeOrder'"
                  >已付款</span
                >
                <span
                  class="status blue"
                  v-if="scope.row.orderStatus === 'pushOrder'"
                  >已付款</span
                >
                <span
                  class="status blue"
                  v-if="scope.row.orderStatus === 'delOrder'"
                  >已取消</span
                >
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="spuName"
              label="发货状态"
            >
              <template slot-scope="scope">
                <span
                  class="status blue"
                  v-if="scope.row.orderStatus === 'createOrder'"
                  >未发货</span
                >
                <span
                  class="status blue"
                  v-if="scope.row.orderStatus === 'payOrder'"
                  >未发货</span
                >
                <span
                  class="status blue"
                  v-if="scope.row.orderStatus === 'deliverOrder'"
                  >已发货</span
                >
                <span
                  class="status blue"
                  v-if="scope.row.orderStatus === 'takeOrder'"
                  >已发货</span
                >
                <span
                  class="status blue"
                  v-if="scope.row.orderStatus === 'pushOrder'"
                  >已发货</span
                >
                <span
                  class="status blue"
                  v-if="scope.row.orderStatus === 'delOrder'"
                  >已取消</span
                >
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="remark"
              label="备注"
            ></el-table-column>
          </el-table>
        </li>
      </ul>
    </div>
    <span slot="footer" class="dialog-footer flex flex-center">
      <el-button @click="close" size="small" type="primary">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: String,
      default: ""
    }
  },
  components: {},
  data() {
    return {
      orderSta: "",
      orderDetails: {},
      orderGoods: [],
      orderStatus: []
    };
  },
  computed: {},
  watch: {
    visible(val) {
      if (val) {
        this.queryDetails();
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    tableRowClassName({ row }) {
      if (row.returnType !== "no") {
        return "tuikuan";
      }
      return "";
    },
    close() {
      this.$emit("close");
    },
    async queryDetails() {
      const res = await this.$store.dispatch("queryOrderDetails", {
        orderId: this.orderId
      });
      this.orderDetails = res.result.order;
      this.orderGoods = [];
      res.result.orderGoods.forEach(v => {
        this.orderGoods.push(...v.goodsList);
      });
      this.orderStatus = res.result.orderStatus;
      let orderSta = res.result.orderStatus[res.result.orderStatus.length - 1];
      let flag = false;
      res.result.orderGoods.map(v => {
        if (v.returnType === "no") {
          flag = true;
        }
      });
      if (flag) {
        let listStatus = [];
        res.result.orderStatus.forEach(v => {
          if (v.orderStatus !== "returnOrder") {
            listStatus.push(v);
          }
        });
        orderSta = listStatus[listStatus.length - 1];
      }

      if (orderSta.orderStatus === "createOrder") {
        this.active = 1;
        this.delOrder = true;
        this.disabled = true;
        this.delivery = true;
        this.orderSta = "待付款";
      } else if (orderSta.orderStatus === "payOrder") {
        this.active = 2;
        this.delOrder = true;
        this.disabled = false;
        this.delivery = true;
        this.orderSta = "待发货";
      } else if (orderSta.orderStatus === "deliverOrder") {
        this.active = 3;
        this.delOrder = true;
        this.orderSta = "已发货";
        this.delivery = false;
        this.disabled = true;
      } else if (orderSta.orderStatus === "takeOrder") {
        this.active = 4;
        this.delOrder = true;
        this.orderSta = "已收货";
        this.delivery = true;
        this.disabled = true;
      } else if (orderSta.orderStatus === "pushOrder") {
        this.active = 5;
        this.delOrder = true;
        this.orderSta = "已评价";
        this.delivery = true;
        this.disabled = true;
      } else if (orderSta.orderStatus === "delOrder") {
        this.delOrder = false;
        this.orderSta = "已取消";
      } else if (orderSta.orderStatus === "returnOrder") {
        this.delOrder = false;
        this.orderSta = "有退货退款";
      }

      // res.result.orderStatus.forEach(v => {
      //   if (v.orderStatus === "createOrder") {
      //     this.createOrderTime = v.createTime;
      //   }
      //   if (v.orderStatus === "payOrder") {
      //     this.payOrderTime = v.createTime;
      //   }
      //   if (v.orderStatus === "deliverOrder") {
      //     this.deliverOrderTime = v.createTime;
      //   }
      //   if (v.orderStatus === "takeOrder") {
      //     this.takeOrderTime = v.createTime;
      //   }
      //   if (v.orderStatus === "pushOrder") {
      //     this.pushOrderTime = v.createTime;
      //   }
      // });
      // let returnDeliver = 0;
      // res.result.orderGoods.forEach(v => {
      //   returnDeliver += v.returnDeliverMoney || 0;
      // });

      this.getRowSpan();
    },
    getRowSpan() {
      this.rowSpanArr = [];
      this.orderGoods.forEach((item, index) => {
        if (index == 0) {
          this.rowSpanArr.push(1);
          this.position = 0;
        } else {
          if (
            this.orderGoods[index].expressQueryId ==
            this.orderGoods[index - 1].expressQueryId
          ) {
            this.rowSpanArr[this.position] += 1; //项目名称相同，合并到同一个数组中
            this.rowSpanArr.push(0);
            this.orderGoods[index].expressQueryId = this.orderGoods[
              index - 1
            ].expressQueryId;
          } else {
            this.rowSpanArr.push(1);
            this.position = index;
          }
        }
      });
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      // 只合并区域位置
      if (columnIndex === 9) {
        const _row = this.rowSpanArr[rowIndex];

        return {
          rowspan: _row, //行
          colspan: 1 //列
        };
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.info-list {
  padding: 0 20px;
}
.info-list,
.logistics-list {
  .title {
    margin-bottom: 20px;
    &::before {
      display: inline-block;
      margin-right: 10px;
      content: "";
      width: 4px;
      height: 12px;
      background: #e50065;
      border-top-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
}
.only-tuikuan {
  opacity: 0.3;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
}
.warning-tuikuan {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
</style>
